import { SwiperInit } from './swiper-init';

document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.swiper3');

  // Return early, and often.
  if (!containers.length) {
    return;
  }

  // Loop through all sliders and assign Swiper object.
  containers.forEach((element) => {
    // Slider 🚀
    SwiperInit(element, {});
  });
});
